__turbopack_context__.v({
  "applied": "_0-HI-W_applied",
  "compact": "_0-HI-W_compact",
  "company": "_0-HI-W_company",
  "company-pic": "_0-HI-W_company-pic",
  "date-posted": "_0-HI-W_date-posted",
  "early-apply": "_0-HI-W_early-apply",
  "grid": "_0-HI-W_grid",
  "header": "_0-HI-W_header",
  "highlight": "_0-HI-W_highlight",
  "highlighted-paragraph": "_0-HI-W_highlighted-paragraph",
  "info": "_0-HI-W_info",
  "job-card-description": "_0-HI-W_job-card-description",
  "job-details": "_0-HI-W_job-details",
  "location": "_0-HI-W_location",
  "one-tap-apply": "_0-HI-W_one-tap-apply",
  "option-message": "_0-HI-W_option-message",
  "option-message-hr": "_0-HI-W_option-message-hr",
  "salary": "_0-HI-W_salary",
  "save": "_0-HI-W_save",
  "search-result": "_0-HI-W_search-result",
  "title": "_0-HI-W_title",
});
